<template>
  <!--<div>-->
  <div class="mobileBox">
    <!--banner+导航-->
    <div class="topBanner">
      <img class="bannerImg" src="../../../assets/img/applyBanner_m.png"/>


      <top-nav></top-nav>


    </div>

    <div class="aboutContent">

      <div class="about01" id="m1">
        <div class="imgBox"><img src="../../../assets/icon/aboutImg1.png"/></div>
        <div class="textBox animated" :class="mm1 ? 'fadeInRight' : 'hideBox'">
          <div class="titleText">我们公司</div>
          <div class="contentText">
            <p>为了满足从事跨境交易的企业和企业的需要，Superiorpay开发了“全球支付解决方案”，其中包括“跨境支付，移动支付，o2o支付，多渠道审计，基于大数据的风险控制和在线”营销”作为业务核心.</p>
            <p>解决了互联网交易“支付转换率低，服务费不系统，交易风险高”等问题，大大提高了支付处理效率，促进了在线交易行业的发展.</p>
          </div>
        </div>
        <div style="clear: both"></div>
      </div>

      <div class="about02" id="m2">
        <div class="imgBox"><img src="../../../assets/icon/aboutImg2.png"/></div>
        <div class="textBox animated" :class="mm2 ? 'fadeInLeft' : 'hideBox'">
          <div class="titleText">我们的产品</div>
          <div class="contentText">
            <p>Superiorpay已经涵盖了包括支付宝和微信支付在内的大多数主流移动支付方式。具有自动服务费计算和一站式财务数据管理功能，支持多渠道账户查询，后台操作简便，统计功能强大。我们能够为企业创建组帐户，这可以使您了解分支机构的业务状况.</p>
          </div>
        </div>
        <div style="clear: both"></div>
      </div>

      <div class="about01 about03" id="m3">
        <div class="imgBox"><img src="../../../assets/icon/aboutImg3.png"/></div>
        <div class="textBox animated" :class="mm3 ? 'fadeInRight' : 'hideBox'">
          <div class="titleText">资金安全</div>
          <div class="contentText">
            <p>在安全性方面，我们公司已获得澳大利亚金融许可证的授权，资金由澳大利亚银行管理。该公司与微信和支付宝正式合作，并采用AML（反洗钱）和AF（反欺诈）法规进行风险控制。我们的基础设施是银行级的安全性。数据传输和存储采用加密算法，可以使资金安全，及时地存入帐户.</p>
          </div>
        </div>
        <div style="clear: both"></div>
      </div>


    </div>

    <!--底部-->
    <div class="footer_m ">
      <div class="footer_mText">
        Supay Technology Pty Ltd. Authorized Representative Number 001283947
        <div class="goTopBtn" @click="toTop"><img src="../../../assets/icon/goTopIcon.png"/></div>
      </div>
    </div>

  </div>
  <!--</div>-->
</template>

<script>
  import topNav from './nav_m'
  let timer = null; //定义初始值
  export default {
    name: "about_m",
    components:{topNav},
    props:{
      step:{   //此数据是控制动画快慢的
        type:Number,
        default:50
      }
    },
    data() {
      return {
        mm1:false,
        mm2:false,
        mm3:false,
        mm4:false,
      }
    },
    destroyed(){
      window.removeEventListener('scroll', this.handleScroll);//监听页面滚动事件
    },
    mounted () {
      document.documentElement.scrollTop=0;
      this.mm1 = true;
      this.mm2 = true;
      this.mm3 = true;
      // this.mm2 = true;
      // this.mm3 = true;
      // window.addEventListener('scroll', this.handleScroll);
    },
    methods:{


      handleScroll () {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

        var offsetTop1 = document.querySelector('#m1').offsetTop;
        // var offsetTop2 = document.querySelector('#m2').offsetTop;
        var offsetTop3 = document.querySelector('#m3').offsetTop;




        if (scrollTop > offsetTop1-600) {
          this.mm2 = true
        }
        if (offsetTop3-scrollTop > 500) {
          this.mm3 = true
        }
      },


      //置顶
      toTop(){ // 动画

        timer = setInterval(function () {
          let osTop = document.documentElement.scrollTop || document.body.scrollTop;
          let ispeed = Math.floor(-osTop / 5);
          document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
          // this.isTop = true
          if (osTop === 0) {
            clearInterval(timer)
          }
        },30)

      },
    }
  }
</script>

<style scoped>
  .mobileBox{width: 100%;height: auto;overflow: hidden;}
  .mobileBox .topBanner{width: 100%;height: auto;position: relative;}
  .mobileBox .topBanner .bannerImg{width: 100%;height: auto;}

  .aboutContent{width: 100%;height: auto;margin-top: -3px;}

  /*版块1*/
  .about01{width: 100%;height: auto;margin-top: -3px;position: relative;}
  .about01 .imgBox{width: 85%;height: auto;float: left;position: absolute;}
  .about01 .imgBox>img{width: 100%;height: auto;}
  .about01 .textBox{width: 60%;min-width: 14rem; min-height: 25rem;overflow-y: auto;float: right;margin-right: 15px;background-color: #fff;margin-top: 3.125rem; padding: 20px;right: 0;box-shadow: 0 0 30px 0px rgba(0,0,0,0.2);position: relative;z-index: 99;}
  .about01 .textBox .titleText{font-size: 1rem;font-family: OpenSans600;color: #4a4a4a;width: 100%;line-height: 2.5rem;text-align: left;}
  .about01 .textBox .contentText{width:100%;height: calc(100% - 10rem);font-family: Montserrat300;font-size: 0.75rem;color: #4a4a4a;line-height: 1.2rem;text-align: left;}
  .about01 .textBox .contentText>p{margin: 10px 0;}

  /*版块2*/
  .about02{width: 100%;height: auto;margin-top: -50px;position: relative;}
  .about02 .imgBox{width: 85%;height: auto;float: right;position: absolute;right: 0;}
  .about02 .imgBox>img{width: 100%;height: auto;}
  .about02 .textBox{width: 60%;min-width: 14rem;min-height: 25rem;overflow-y: auto; float: left;margin-left: 15px;background-color: #fff;margin-top: 11.25rem; padding: 20px;right: 0;box-shadow: 0 0 30px 0px rgba(0,0,0,0.2);position: relative;z-index: 99;}
  .about02 .textBox .titleText{font-size: 1rem;font-family: OpenSans600;color: #4a4a4a;width: 100%;line-height: 2.5rem;text-align: left;}
  .about02 .textBox .contentText{width:100%;height: calc(100% - 10rem);font-family: Montserrat300;font-size: 0.75rem;color: #4a4a4a;line-height: 1.2rem;text-align: left;}
  .about02 .textBox .contentText>p{margin: 10px 0;}


  /*板块3*/
  .about03{margin-top: -50px;margin-bottom: 100px;}
  .about03 .textBox{margin-top: 12.5rem;}

  .hideBox{display: none;}


  @media screen and (min-width: 760px) {
    .about01 .textBox{width: 50%;margin-top: 17.125rem;}
    .about02{margin-top: -65px;}
    .about02 .textBox{width: 50%;}
    .about01 .imgBox{width: 75%;}
    .about02 .imgBox{width: 75%;}
  }
  @media screen and (min-width: 950px) {
    .about01 .imgBox{width: 65%;}
    .about02 .imgBox{width: 65%;}
    .about01 .textBox{width: 45%;margin-top: 25.125rem;}
    .about02 .textBox{width: 45%;margin-top: 22.25rem;}
    .about02{margin-top: -50px;}

  }




</style>
